// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { setDay as fn } from "../setDay.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setDayWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default setDayWithOptions;
